import { useState } from "react"
import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table20 from "./components/Factors/Table/Table20";

const PageG10 = ({ reload }) => {
  const [stressScore, setStressScore] = useState("")
  return (
    <>
      <Page pageNumber={34}>
        <HeaderFactors
          numberFactors="عامل بیستم"
          titelFactors="استرس و شرایط غير عادی کار"
          maxValue="40"
          jsValue={stressScore}
        />
        <ExplainFactor
          text="منظور از این عامل شرایط غیر عادی مربوط به ساعات کار نامنظم، استرس، تضاد یا ابهام در نقش، و احضار
          به محل کار در شبانه روز، سرکشی و سرپرستی در محل کار می باشد"
        />
        <SpaceBetweenTables />
        <Table20 setStressScore={setStressScore} stressScore={stressScore} reload={reload}/>
      </Page>
    </>
  );
};

export default PageG10;
